import styled from "@emotion/styled";
import { Drawer } from "antd";
import { useState } from "react";
import { DrawTitle } from "screens/forms/form-utils";
import {
  RestaurantListOnGroupTitle,
} from "screens/register/contant";
import { CloseOutlinedBox } from "screens/register/page-drawer-join";
import closeIcon from "assets/closeIcon.png";
import { LabelType } from "screens/register/page-header";
import { useAuth } from "context/auth-context";
import { LOCAL } from "@fantuaneats/chowbus-web-stripe-payment";
import positionIcon from "assets/position_icon.png";

export const RestaurantListInRestarantGroup = (props: {
  lang: LabelType;
  onOpenChanged: (open: boolean) => void;
}) => {
  const { restaurantGroupInfo } = useAuth();
  const [open, setOpen] = useState(true);

  const otherStyleObj = {
    orderContent: {
      padding: "0 1.6rem",
      height: "calc(80vh - 5rem)",
      overflow: "auto",
    },
    emptyText: {
      height: "70%",
      color: "#92929F",
      fontWeight: 600,
      fontSize: "1.8rem",
    },
    loadingStyle: (page: number) => {
      const obj = {};
      if (page === 1) {
        Object.assign(obj, {
          height: "calc(80vh - 5rem)",
          display: "flex",
          alignItems: "center" as const,
          justifyContent: "center",
        });
      } else {
        Object.assign(obj, { height: "3rem", textAlign: "center" as const });
      }
      return obj;
    },
    orderTitle: {
      left: { display: "inline-block", marginBottom: "0.4rem" },
      right: { display: "inline-block", whiteSpace: "nowrap" as const },
    },
  };


  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Drawer open={open}
      placement={"bottom"}
      forceRender={true}
      destroyOnClose={true}
      width={"100vw"}
      // 初始是 24.4 和
      height={"80vh"}
      closable={false}
      style={{ padding: 0, borderRadius: "1.2rem 1.2rem 0 0" }}
      bodyStyle={{ padding: 0 }}
      className={"drawClasses"}
      afterOpenChange={props.onOpenChanged}
    >
      <DrawTitle style={{ marginBottom: 0 }}>
        <CloseOutlinedBox src={closeIcon} onClick={handleClose} />
        <span style={{ fontSize: "1.8rem" }}>
          {RestaurantListOnGroupTitle[props.lang]}
        </span>
      </DrawTitle>
      {/* 订单内容 */}
      <div style={otherStyleObj.orderContent}>
        {(restaurantGroupInfo?.includRestaurantList || []).map((restaurantItem, index) => {
          let { name: _name_, foreign_name, id, address, logo_url } = restaurantItem;
          let { address1, address2, city, zip_code, state } = address || {};
          let name = (props.lang === LOCAL.EN ? _name_ : foreign_name) || _name_;
          let address_composed = `${address1} ${address2} ${city} ${state} ${zip_code}`
          return (
            <RestuarntItem
              key={"restaurant_" + id}
              isEndOrder={index === (restaurantGroupInfo?.includRestaurantList || []).length - 1}
            >
              {logo_url && <RestaurantLogo logoUrl={logo_url || ''} />}
              <div>
                <RestaurantName>{name}</RestaurantName>
                <RestaurantAddress>{address_composed}</RestaurantAddress>
              </div>
            </RestuarntItem>
          );
        })
        }
      </div>
    </Drawer>
  );
};

const RestaurantName = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 1.8rem;
  color: #1D1B2E;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const RestaurantAddress = styled.div`
font-style: normal;
font-weight: 400;
font-size: 1.2rem;
line-height:1.2rem;
color: #92929F;
margin-top:0.8rem;
display: flex;
align-items: center;
&::before{
  content:'';
  width:1.6rem;
  height:1.6rem;
  display:inline-block;
  background-image: url(${positionIcon});
  background-size:contain;
  background-repeat:no-repeat;
  background-position:center;
}
`;

const RestuarntItem = styled.div<{
  isEndOrder: boolean;
}>`
  border-bottom: ${(props) =>
    !props.isEndOrder ? "1px solid #c0c2cc" : "none"};
  margin-top: 1.6rem;
  display:flex;
  align-items:center;
  padding-bottom: 1.6rem;
`;

const RestaurantLogo = styled.div<{
  logoUrl: string;
}>`
  width:5.4rem;
  height:5.4rem;
  background-image: ${(props) =>
    props.logoUrl ? `url(${props.logoUrl})` : 'none'
  };
  background-size:cover;
  background-repeat:no-repeat;
  background-position:center;
  border-radius: 100%;
  border: 1px solid #1D1B2E;
  background-color:#ffffff;
  margin-right:1rem;
  flex-shrink: 0;
`;



